import { createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/img/helpharma.png'


const _hoisted_1 = { class: "login-box" }
const _hoisted_2 = { class: "card card-outline card-primary" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    srcset: ""
  })
], -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "oldPassword" }, "Contraseña temporal", -1)
const _hoisted_7 = { class: "input-group mb-3" }
const _hoisted_8 = ["type"]
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Nueva contraseña", -1)
const _hoisted_11 = { class: "input-group mb-3" }
const _hoisted_12 = ["type"]
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "confirmPassword" }, "Confirmación de contraseña", -1)
const _hoisted_15 = { class: "input-group mb-3" }
const _hoisted_16 = ["type"]
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Reestablecer ")

export function render(_ctx, _cache) {
  const _component_app_button = _resolveComponent("app-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers((...args) => (_ctx.changePassword && _ctx.changePassword(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: _ctx.showUserOldPassword ? 'text':'password',
                class: _normalizeClass({'form-control': true,  'is-invalid': _ctx.v$.oldPassword.$error,  'is-valid': !_ctx.v$.oldPassword.$error }),
                id: "oldPassword",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.v$.oldPassword.$model) = $event)),
                placeholder: "Contraseña",
                autocomplete: "off"
              }, null, 10, _hoisted_8), [
                [_vModelDynamic, _ctx.v$.oldPassword.$model]
              ]),
              _createElementVNode("span", {
                class: "input-group-text rounded-left-0 rounded-right",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.showUserOldPassword = !_ctx.showUserOldPassword))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass([_ctx.showUserOldPassword ? 'fas fa-eye-slash' : 'fas fa-eye'])
                }, null, 2)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.oldPassword.$errors, (error) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "error invalid-feedback",
                  key: error.$uid
                }, _toDisplayString(error.$message), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: _ctx.showUserPassword ? 'text':'password',
                class: _normalizeClass({'form-control': true,  'is-invalid': _ctx.v$.password.$error,  'is-valid': !_ctx.v$.password.$error }),
                id: "password",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.v$.password.$model) = $event)),
                placeholder: "Contraseña",
                autocomplete: "off"
              }, null, 10, _hoisted_12), [
                [_vModelDynamic, _ctx.v$.password.$model]
              ]),
              _createElementVNode("span", {
                class: "input-group-text rounded-left-0 rounded-right",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.showUserPassword = !_ctx.showUserPassword))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass([_ctx.showUserPassword ? 'fas fa-eye-slash' : 'fas fa-eye'])
                }, null, 2)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.password.$errors, (error) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "error invalid-feedback",
                  key: error.$uid
                }, _toDisplayString(error.$message), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                type: _ctx.showUserPasswordConfirm ? 'text':'password',
                class: _normalizeClass({'form-control': true,  'is-invalid': _ctx.v$.confirmPassword.$error,  'is-valid': !_ctx.v$.confirmPassword.$error }),
                id: "confirmPassword",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.v$.confirmPassword.$model) = $event)),
                placeholder: "Confirmación de Contraseña",
                autocomplete: "off"
              }, null, 10, _hoisted_16), [
                [_vModelDynamic, _ctx.v$.confirmPassword.$model]
              ]),
              _createElementVNode("span", {
                class: "input-group-text rounded-left-0 rounded-right",
                onClick: _cache[5] || (_cache[5] = $event => (_ctx.showUserPasswordConfirm = !_ctx.showUserPasswordConfirm))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass([_ctx.showUserPasswordConfirm ? 'fas fa-eye-slash' : 'fas fa-eye'])
                }, null, 2)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.confirmPassword.$errors, (error) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "error invalid-feedback",
                  key: error.$uid
                }, _toDisplayString(error.$message), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_app_button, {
                class: "btn-primary",
                type: "submit",
                block: "true",
                loading: _ctx.isBtnLoading
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ], 32)
      ])
    ])
  ]))
}